// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.download-link {\n  color: blue;\n}", "",{"version":3,"sources":["webpack://src/components/AuthenticatedLink/styles.scss"],"names":[],"mappings":"AACA;EACE,WAAA;AAAF","sourcesContent":["@import \"../../styles/colors.scss\";\na.download-link {\n  color: blue;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
